import { useEffect } from 'react'

import type { RealtySearchRequest } from 'shared/api/kyrgyzstan/search'

import { BestOffersPageSize, kyrgyzstanBestOffersStore } from '../model'

interface UseBestOffersOptions {
  limit?: number
}

export const useBestOffers = (options?: UseBestOffersOptions) => {
  const { limit } = options || {}

  const {
    offers,
    isLoading,
    error,
    fetchFavorites,
    loadMore,
    hasMore,
    realtyTypeId,
    setRealtyTypeId,
    reset,
  } = kyrgyzstanBestOffersStore

  useEffect(() => {
    const pageSize = limit || BestOffersPageSize

    void fetchFavorites({
      page: 1,
      page_size: pageSize,
      realty_type_id:
        realtyTypeId !== 0 && realtyTypeId !== undefined
          ? String(realtyTypeId)
          : undefined,
    })
  }, [limit, realtyTypeId])

  const displayedOffers = limit ? offers.slice(0, limit) : offers

  const handleSetRealtyTypeId = (id?: number) => {
    if (realtyTypeId === id) {
      return
    }

    reset()
    setRealtyTypeId(id)
  }

  return {
    offers: displayedOffers,
    allOffers: offers,
    isLoading,
    error,
    hasMore,
    realtyTypeId,
    setRealtyTypeId: handleSetRealtyTypeId,
    reset,
    fetchFavorites: (params?: Partial<RealtySearchRequest>) =>
      void fetchFavorites(params),
    loadMore: () => void loadMore(),
  }
}
